import React from 'react'
import { useSelector } from 'react-redux'
import MarkdownCell from 'src/components/Table/CellComponents/MarkdownCell'
import Table, { ColumnDef } from 'src/components/Table/Table'
import { Asset } from 'src/types'

const TableHidden = ({ assets }: { assets: Asset[] }) => {
  const isSec = useSelector((s: any) => s?.user?.customerId?.includes('SEC'))

  const cols: ColumnDef[] = [
    { name: 'prinexId' },
    { name: 'address' },
    { name: 'error', component: MarkdownCell }
  ]

  if (isSec) cols.push({ name: 'customerId' })

  return (
    <Table
      name={'hidden-assets'}
      className={isSec ? 'sec' : null}
      data={assets}
      columns={cols}
      pageSize={50}
    />
  )
}

export default TableHidden
